export default {"src":"/_next/static/media/user-new.e7945926.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};